export default "__VITE_ASSET__BjnLXhfw__"